export const LOAD_FRACCIONARANCELARIA_SUCCESS = 'LOAD_FRACCIONARANCELARIA_SUCCESS';

export interface ClaveFraccionArancelariaState {
    clave: string
    descripcion: string
    descripcionMercancia:string
    uuidComprobante?: string
    peso?: number
}

interface ILoadClavesFraccionArancelaria {
    type: typeof LOAD_FRACCIONARANCELARIA_SUCCESS
    clavesFraccionArancelaria: ClaveFraccionArancelariaState[]
}

export type ClaveFraccionArancelariaActionTypes = ILoadClavesFraccionArancelaria
